import { CoreApi, PartKey, ProductType } from '@inter-ikea-storageone/range';
import { BestaOpeningFunctionComponent } from '@inter-ikea-storageone/range-besta';
import { ComponentIds, Entity, HierarchyUtils, ProductPartComponent } from '@inter-ikea-core/core';
import { getEntityConnectorsThatOffer } from 'rangeConfig/shared/utils/connectors';

export const isOpeningTypePushOpen = (coreApi: CoreApi) => {
  const fronts = coreApi.entities.getByComponent(BestaOpeningFunctionComponent.id);

  return !fronts.some(
    front =>
      front.getComponent<BestaOpeningFunctionComponent>(BestaOpeningFunctionComponent.id)
        ?.openingFunction === ProductType.BESTA_SOFT_CLOSING
  );
};

export const getFrameConnectorsByKey = (frameAssembly: Entity, key: string) => {
  const frame = HierarchyUtils.children(frameAssembly).find(
    child =>
      child.getComponent<ProductPartComponent>(ComponentIds.PRODUCT_PART_COMPONENT_ID)?.partKey ===
      PartKey.FRAME
  );

  const connectors = frame ? getEntityConnectorsThatOffer(frame, key) : null;

  return connectors ? connectors : [];
};
